import { render, staticRenderFns } from "./EmployeeSecondFamilyNameField.vue?vue&type=template&id=1791955e&"
import script from "./EmployeeSecondFamilyNameField.vue?vue&type=script&lang=js&"
export * from "./EmployeeSecondFamilyNameField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports